export enum EBusinessReferralDiscountType {
  PERCENTAGE = 'percentage',
  MONEY = 'money',
  COINS = 'coins'
}

export enum EBusinessReferralType {
  BOTH = 'both',
  REFERRING = 'referring',
  REFERRED = 'referred'
}

export type TBusinessReferralDiscountType = 'percentage' | 'money' | 'coins';

export type TBusinessReferralType = 'both' | 'referring' | 'referred';

export interface IBusinessReferral {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  referringDiscount?: string | number;
  referringDiscountType?: TBusinessReferralDiscountType;
  referredDiscount?: string | number;
  referredDiscountType?: TBusinessReferralDiscountType;
  referringMinimumValue?: string;
  referredMinimumValue?: string;
  isActive?: boolean;
  referredPrefix?: string;
  referringPrefix?: string;
  referredMetaImage?: string;
  coinsRewarded?: number;
  conversion?: number;
  joinedMembers?: number;
  purchases?: number;
  revenue?: number;
}
export interface IBusinessReferralChart {
  purchases?: number;
  signUps?: number;
}
